import styled from "styled-components";

export const CarouselWrapper = styled.div`
  max-width: 520px;
  margin: 0 auto 50px;
  padding: 0 12px;

  .slick-slider {
    border-radius: 28px;
    overflow: hidden;
  }

  .slick-list {
    border-radius: 28px;
    background: #111;
    border: 1px solid rgba(255, 255, 255, 0.08);
    box-shadow: 0 30px 80px rgba(0, 0, 0, 0.45);
  }

  .slick-slide > div {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 560px;
    padding: 0;
  }

  .slick-dots {
    bottom: -36px;

    li button:before {
      color: #ff7a00;
      opacity: 0.35;
      font-size: 10px;
    }

    li.slick-active button:before {
      opacity: 1;
      color: #ff7a00;
    }
  }

  .slick-prev,
  .slick-next {
    z-index: 2;
    width: 40px;
    height: 40px;

    &:before {
      font-size: 32px;
      color: #ff7a00;
      opacity: 0.9;
    }

    &:hover:before {
      opacity: 1;
    }
  }

  .slick-prev {
    left: -8px;
  }

  .slick-next {
    right: -8px;
  }

  @media (max-width: 768px) {
    max-width: 100%;
    margin-bottom: 40px;
    padding: 0 8px;
  }

  @media (max-width: 600px) {
    padding: 0 4px;

    .slick-slide > div {
      min-height: 360px;
      padding: 12px;
    }

    .slick-prev,
    .slick-next {
      width: 36px;
      height: 36px;

      &:before {
        font-size: 26px;
      }
    }

    .slick-prev {
      left: 2px;
    }

    .slick-next {
      right: 2px;
    }

    .slick-dots {
      bottom: -32px;
    }
  }
`;

export const Slide = styled.div`
  outline: none;
`;

export const SlideImage = styled.img`
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
  object-fit: contain;
  object-position: center;
`;
